// extracted by mini-css-extract-plugin
export default {"heading":"SystemsSection_heading__4HCtN"};